module.exports = __webpack_public_path__ + "static/media/slider-6.c7d1546f.jpg";